import request from '@/utils/request'

/**
 * 申请退货订单商品
 * @param {Object} data 退货商品信息
 * @returns {Promise}
 */
export function applyReturnStoreCarts(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderCartReturn/applyReturnStoreCarts',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}